<template>
  <div class="dashboard-grid">
    <header class="dashboard-header">
      <slot name="header" />
    </header>

    <aside class="sidebar-container">
      <slot name="sidebar" />
    </aside>

    <main class="main-content" @click="isMobileOpen = false">
      <slot />
    </main>
  </div>
</template>

<script>
export default {
  name: 'DashboardLayout',
  data() {
    return {
      isCollapsed: false,
      isMobileOpen: false
    };
  }
}
</script>

<style scoped>
.dashboard-grid {
  display: grid;
  grid-template-areas:
    "header  header"
    "sidebar main";
  grid-template-columns: var(--sidebar-width) 1fr;
  grid-template-rows: auto 1fr;
  height: 100vh;
  background: var(--color-bg);
}

/* Header spans full width */
.dashboard-header {
  grid-area: header;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--header-bg);
  color: var(--header-text);
  border-bottom: 1px solid var(--header-border);
  padding: 0 var(--space-md);
  height: 72px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  z-index: 10;
}

/* Sidebar in left column */
.sidebar-container {
  grid-area: sidebar;
  background: var(--sidebar-bg);
  border-right: 1px solid var(--sidebar-border);
  overflow-y: auto;
  transition: width 0.3s ease;
}

/* Main content in right column */
.main-content {
  grid-area: main;
  padding: var(--space-md);
  background: var(--color-bg);
  color: var(--color-text);
  overflow-y: auto;
}

/* Tablet & below: collapse sidebar column to icon-only width */
@media (max-width: 1024px) {
  .dashboard-grid {
    grid-template-columns: var(--sidebar-collapsed-width) 1fr;
  }
  .sidebar-container {
    width: var(--sidebar-collapsed-width);
  }
}
</style>
